import React from 'react';
import './Contact.css';
import { IconButton, Typography } from '@material-ui/core';
import { GitHub, LinkedIn, Instagram, Email } from '@material-ui/icons';

export default function Contact() {
  return (
    <footer>
      <Typography align="center">Let's connect</Typography>
      <div className="footer__links">
        <a href="mailto:bennettoh.dev@gmail.com" target="_blank" title="email">
          <IconButton>
            <Email />
          </IconButton>
        </a>
        <a href="https://instagram.com/bennett.oh" target="_blank" title="github">
          <IconButton>
            <Instagram />
          </IconButton>
        </a>
        <a href="https://github.com/bennettoh" target="_blank" title="github">
          <IconButton>
            <GitHub />
          </IconButton>
        </a>
        <a href="https://www.linkedin.com/in/ohbennett" target="_blank" title="linkedin">
          <IconButton>
            <LinkedIn />
          </IconButton>
        </a>
      </div>
    </footer>
  );
}